import { render, staticRenderFns } from "./dialog-newalert-inbox-outbox.vue?vue&type=template&id=622634e4&"
import script from "./dialog-newalert-inbox-outbox.vue?vue&type=script&lang=js&"
export * from "./dialog-newalert-inbox-outbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports